
import {updateFilterUrl, parseFilterUrl} from './functions/url';
import {filterItems} from './functions/filters';

import React, { useState, useEffect } from 'react';

import Grid from './components/Grid';
import TopFilters from './components/TopFilters';
import SideFilters from './components/SideFilters';
import SideFiltersNav from './components/SideFiltersNav';
import SelectedFilters from './components/SelectedFilters.js';
import Pagination from './components/Pagination';

import SelectedTopFilter from './components/SelectedTopFilter.js';
import TotalResults from './components/TotalResults.js';
import TotalResultsBottom from './components/TotalResultsBottom.js';

import HiddenSearch from './components/HiddenSearch.js';

import { FilterContextProvider } from "./context/context";



function FilterUI(props) {

  const {
    filter_form,
    top_filters,
    items,
    active_filters,
    start_date,
    end_date,
    current_page
  } = props;

  const [selectedFilters, setSelectedFilters] = useState(filter_form);
  const [activeFilters, setActiveFilters] = useState(active_filters);
  const [startDate, setStartDate] = useState(start_date);
  const [endDate, setEndDate] = useState(end_date);
  const [filteredItems, setFilteredItems] = useState(items);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(current_page);

  const states = {
    selectedFilters, setSelectedFilters,
    activeFilters, setActiveFilters,
    startDate, setStartDate,
    endDate, setEndDate,
    filteredItems, setFilteredItems,
    searchQuery, setSearchQuery,
    currentPage, setCurrentPage
  };

  useEffect(() => {
    updateFilterUrl(selectedFilters, currentPage);
    let filter_items = filterItems(items, selectedFilters, searchQuery);
    setFilteredItems(filter_items);

    let totalPageCount = Math.ceil(filter_items.length / 12);
    if (currentPage > totalPageCount ){
      setCurrentPage(totalPageCount > 0 ? totalPageCount : 1);
    }

  }, [selectedFilters, searchQuery, currentPage]);


  const toggleFilterPanel = (panel) => {
    let active_filters = activeFilters;
    // bodyScrollLock.clearAllBodyScrollLocks();

    if (active_filters.active_panel === panel && active_filters.mobile_open ){
      active_filters.mobile_open = false;
      document.querySelector('body').classList.remove('filter-open');
      // bodyScrollLock.clearAllBodyScrollLocks();
    } else {
      active_filters.mobile_open = true;
      document.querySelector('body').classList.add('filter-open');
      // bodyScrollLock.clearAllBodyScrollLocks();
      // bodyScrollLock.disableBodyScroll('.side-filter-section-inner')
    }

    active_filters.active_panel = panel;

    setActiveFilters(
      {...activeFilters},
      active_filters
    )
  }


  const closeFilterPanel = () => {
      let active_filters = {
          mobile_open: false,
          active_panel: 'side_filter',
          top_filter_open: false,
          side_filter_open: false,
          active_side_filter: '',
          active_date_panel: ''
      };

      document.querySelector('body').classList.remove('filter-open');
      // bodyScrollLock.clearAllBodyScrollLocks();

      setActiveFilters(
        active_filters
      )
  }

  const toggleMobileFilters = () => {
      let active_filters = activeFilters;
      active_filters.mobile_open = !activeFilters.mobile_open;
      active_filters.active_side_filter = "";
      if (active_filters.mobile_open) {
        document.querySelector('body').classList.add('filter-open');
        // bodyScrollLock.clearAllBodyScrollLocks();
        //
        // bodyScrollLock.disableBodyScroll('.side-filter-section-inner')

      } else {
        document.querySelector('body').classList.remove('filter-open');
        // bodyScrollLock.clearAllBodyScrollLocks();
      }

      setActiveFilters(
        {...activeFilters},
        active_filters
      )
  }


  return (
    <>


      <FilterContextProvider value={states}>
        <div
          className={`filters-bg ${activeFilters.mobile_open || activeFilters.active_side_filter.length > 0 ? "active" : ""}`}
          onClick={() => closeFilterPanel('')}
        >
        </div>

        <div className={`filters ${activeFilters.mobile_open ? "active" : ""}`}>
          <div className="mobile-triggers">
            <div className="mobile-pullup" onClick={() => toggleMobileFilters()}>
              <div className="sep"></div>
              <button
                className={`close ${activeFilters.mobile_open ? "active" : ""}`}>
                Close
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11" fill="none">
                  <path d="M2 9.5L9.99872 1.50128" stroke="black" strokeWidth="2" strokeLinecap="square"/>
                  <path d="M9.99902 9.5L2.00031 1.50128" stroke="black" strokeWidth="2" strokeLinecap="square"/>
                </svg>
              </button>
            </div>
            <button className={`filter-trigger trigger-side ${activeFilters.mobile_open && activeFilters.active_panel === "side_filter" ? "active" : ""}`}  onClick={() => toggleFilterPanel("side_filter")}>
              <span>
              Filter by
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="9" viewBox="0 0 12 9" fill="none">
                <path d="M9 3L6 6L3 3" stroke="white" strokeWidth="3" strokeLinecap="square"/>
              </svg>
              </span>
            </button>
            {Object.keys(top_filters).length &&
              <button className={`filter-trigger trigger-top  ${activeFilters.mobile_open && activeFilters.active_panel === "top_filter" ? "active" : ""}`}  onClick={() => toggleFilterPanel("top_filter")}>
                <span>
                  Explore
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="9" viewBox="0 0 12 9" fill="none">
                   <path d="M9 3L6 6L3 3" stroke="white" strokeWidth="3" strokeLinecap="square"/>
                  </svg>
                </span>
                <span className="selected-top-filter"><SelectedTopFilter /></span>
              </button>
            }

          </div>

          <div className={`panel panel-top  ${activeFilters.active_panel === "top_filter" ? "active" : ""}`}>
            <TopFilters
              form={top_filters}
            />
          </div>
          <div className={`panel panel-side  ${activeFilters.active_panel === "side_filter" ? "active" : ""}`}>
            <SideFiltersNav
              form={filter_form}
            />
            <SideFilters
              form={filter_form}
            />
          </div>

        </div>

        <div className="filters-right">
            <TopFilters
              form={top_filters}
            />
            {Object.keys(top_filters).length &&
              <div className="selected-title font-title font-1"><SelectedTopFilter /></div>
            }

            <TotalResults />
            <Grid />
            <HiddenSearch />

            <TotalResultsBottom />


            <Pagination
              className="pagination-bar"
              currentPage={currentPage}
              totalCount={filteredItems.length}
              pageSize={12}
              onPageChange={page => setCurrentPage(page)}
            />
        </div>




      </FilterContextProvider>
    </>
  );
}

export default FilterUI;
